// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"896c492c","65":"073218c5","79":"21de6155","160":"167e5443","328":"34de2978","374":"dd2347be","623":"1ff20c97","705":"a832c083","787":"4f745b34","862":"6b1f05a8","956":"14a4709f","963":"c810c705"}[chunkId] + ".chunk.js";
};